import React from 'react'
export default function(props){
  return <div className="message message_loading loading loading-markets">Loading {props.event}&hellip;</div>
}
